import { useState } from "react";
import { Card, CardBody, Col, Input } from "reactstrap";
import { Btn, P } from "../../../../../AbstractElements";
import CommonCardHeader from "../../../../../Utils/CommonComponents/CommonCardHeader";
import { ClipboardOnTextAreaTitle, Copy, Cut, CutCopyFromTextArea } from "../../../../../Utils/Constants";

export default function ClipboardOnTextArea() {
  const clipboardOnTextAreaText: string = "A web designer must always enhance their work since creating websites is a creative effort. Therefore, a web designer must be more imaginative to produce exceptional results. Blogs about web design assist web designers in learning about new technologies, offer lessons, news, direction for a freebie, and much more. These blogs allow web designers to stay creative and improve their abilities. Therefore, advice from web design blogs is required to improve your business.";
  const [clipBoardOnTextAreaValue, setClipBoardOnTextAreaValue] = useState(clipboardOnTextAreaText);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(clipBoardOnTextAreaValue);
    setClipBoardOnTextAreaValue(clipBoardOnTextAreaValue);
  };

  const handleCut = async () => {
    await navigator.clipboard.writeText(clipBoardOnTextAreaValue);
    setClipBoardOnTextAreaValue("");
  };
  return (
    <Col sm={12} md={6}>
      <Card>
        <CommonCardHeader headClass="pb-0" title={ClipboardOnTextAreaTitle} />
        <CardBody>
          <div className="clipboaard-container">
            <P className="f-16">{CutCopyFromTextArea}</P>
            <Input type="textarea" onChange={(event) => setClipBoardOnTextAreaValue(event.target.value)} className="f-14" rows={3} value={clipBoardOnTextAreaValue} />
            <div className="mt-3 text-end">
              <Btn className="btn-clipboard me-2" color="warning" onClick={handleCopy}>
                <i className="fa fa-copy"></i> {Copy}
              </Btn>
              <Btn className="btn-clipboard-cut" color="success" onClick={handleCut}>
                <i className="fa fa-cut"></i> {Cut}
              </Btn>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}
